export function publicTableReducer(
  state = {
    allPublicData: [],
    todayPublicData: [],
    upcommingPublicData: [],
    loadings: false,
  },
  { type, payload }
) {
  switch (type) {
    case "ALL_PUBLIC_TABLE":
      return { ...state, allPublicData: payload, loadings: false };
    case "TODAY_PUBLIC_TABLE":
      return { ...state, todayPublicData: payload, loadings: false };
    case "UPCOMMING_PUBLIC_TABLE":
      return { ...state, upcommingPublicData: payload, loadings: false };
    case "LOADDED_PUBLIC":
      return { ...state, loadings: false };
    case "LOADING_PUBLIC":
      return { ...state, loadings: true };

    default:
      return state;
  }
}


